import React from 'react';
import { jc } from 'utils';
import { mediaGallery } from './styles';

export type MediaGalleryProps = React.HTMLAttributes<HTMLElement>;

export const MediaGallery: React.FC<MediaGalleryProps> = ({ children, className = '', ...htmlProps }) => {
  return (
    <div className={jc(className, mediaGallery)} {...htmlProps}>
      {children}
    </div>
  );
};
